import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

interface NewsCardProps {
  news: NewsItem;
  variant?: "grid" | "row";
}

export default function NewsCard({ news, variant = "grid" }: NewsCardProps) {
  if (variant === "row") {
    return (
      <Link
        to={`/news/detail/${news.id}`}
        className="group flex w-full cursor-pointer flex-col gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row md:p-5"
      >
        <div className="relative h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44">
          <img
            src={news.cover}
            alt={`${news.title} 配图`}
            title={`${news.title} 动漫资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
            <span className="rounded-full bg-accent-50 px-2 py-0.5 font-medium text-accent-700">
              {news.category}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" />
              {news.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-user-line" />
              {news.author}
            </span>
          </div>
          <h3 className="mt-2 font-heading text-base font-bold leading-6 text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
            {news.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{news.excerpt}</p>
          <span className="mt-auto hidden items-center gap-1 pt-3 text-xs font-semibold text-primary-600 opacity-0 transition-opacity group-hover:opacity-100 sm:flex">
            阅读全文
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${news.id}`}
      className="group flex w-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden bg-background-200 md:h-48">
        <img
          src={news.cover}
          alt={`${news.title} 配图`}
          title={`${news.title} 动漫资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[10px] font-semibold text-accent-700">
          {news.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <span className="text-[11px] text-foreground-400">{news.date}</span>
        <h3 className="mt-2 line-clamp-2 font-heading text-sm font-bold leading-6 text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {news.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-6 text-foreground-600 md:text-sm">{news.excerpt}</p>
        <span className="mt-auto flex items-center gap-1 pt-4 text-xs font-semibold text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}